import { render, staticRenderFns } from "./LmImagenPages.vue?vue&type=template&id=62878158"
import script from "./LmImagenPages.vue?vue&type=script&lang=js"
export * from "./LmImagenPages.vue?vue&type=script&lang=js"
import style0 from "./LmImagenPages.vue?vue&type=style&index=0&id=62878158&prod&lang=sass&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports